export const integrationCols = [
  {
    accessor: 'license',
    Header: 'Matrícula',
    headerProps: { title: 'Ordenar por matrícula' }
  },
  {
    accessor: 'apikey',
    Header: 'API Key',
    headerProps: { title: 'Ordenar por apikey' }
  },
  {
    accessor: 'apikeyName',
    Header: 'Nombre de API Key',
    headerProps: { title: 'Ordenar por nombre de apikey' }
  },
  {
    accessor: 'realEstate',
    Header: 'Inmobiliaria',
    headerProps: { title: 'Ordenar por inmobiliaria' }
  },
  {
    accessor: 'branchOffice',
    Header: 'Sucursal',
    headerProps: { title: 'Ordenar por sucursal' }
  },
  {
    accessor: 'user',
    Header: 'Usuario',
    headerProps: { title: 'Ordenar por usuarios' }
  },
  {
    accessor: 'propsPublished',
    Header: 'Props. publicadas',
    headerProps: { title: 'Ordenar por publicadas' }
  }
];

export const mockData = [
  {
    license: '1234',
    apikey: 'aa4qwr25qwr3q1af55474tsd564',
    apikeyName: 'App1',
    realEstate: 'Inmobiliaria Gonzalez',
    branchOffice: 'Casa Central',
    user: 'Juan Gonzalez',
    propsPublished: 10
  },
  {
    license: '5678',
    apikey: 'aa4iyr02qwr3q2af55389tps564',
    apikeyName: 'App2',
    realEstate: 'Inmobiliaria Fernandez',
    branchOffice: 'Casa Central',
    user: 'Juan Fernandez',
    propsPublished: 20
  }
];
